// src/components/PageIndicator.jsx
import { useState, useEffect } from 'react';
import { SECTIONS } from '../data/content';

export default function PageIndicator() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY + window.innerHeight / 2;
      let curr = 0;
      SECTIONS.forEach((id, i) => {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollY) curr = i;
      });
      setActive(curr);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="page-indicator">
      {SECTIONS.map((id, i) => (
        <div
          key={id}
          className={`pi-dot${active === i ? ' active' : ''}`}
          onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })}
          title={id}
        />
      ))}
    </div>
  );
}
